import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import peopleInAnOfficeSpaceWebp from './images/people-in-an-office-space.webp';
// styles
import {
  PictureStyled,
  RowReverseStyled,
} from './styles';

export default () => {
  return (
    <SectionContainer
      id='business-services-intro'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            align='center'
            nextElement='graphic'>
            Your business is our business.
          </Typography>
        </Col>
      </Row>
      <RowReverseStyled align='center'>
        <Col
          small={10}
          medium={6}>
          <PictureStyled
            desktopWebpSrc={peopleInAnOfficeSpaceWebp}
            src={peopleInAnOfficeSpaceWebp}
            altText='People working in an office space.' />
        </Col>
        <Col medium={6}>
          <Typography disableBottomPadding>
            From initial startup to eventually passing your business on, we&#39;re here to help you at every stage. From protecting against risk and managing growth, to attracting and retaining the top talent, our business services will be there to guide you.
          </Typography>
        </Col>
      </RowReverseStyled>
    </SectionContainer>
  );
};
